import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/inventory-stocks/profile/loading';

export const Route = createFileRoute('/_private/settings/inventory-stocks/$id')({
  pendingComponent: Loading,
});
